import React from 'react';

import NavLinks from './NavLinks';
import Social from './Social';

import logo from '../logo-inverted.svg';

import './MainNav.css';

class MainNav extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		}
	}

	show() {
		this.setState({
			open: !this.state.open
		})
	}

	render() {
		return (
			<nav className={ (this.state.open) ? 'fullscreen-nav' : '' }>
				
				<h1 className={ (this.state.open) ? 'App__header-title--nav' : 'hide' }><img src={logo} className="App-logo" alt="logo" /> <span className="App__title">Rob Lee</span></h1>

				<div className={ (this.state.open) ? 'navToggle open' : 'navToggle' } onClick={this.show.bind(this)}>
					<div className="icon"></div>
				</div>
				<div className={ (this.state.open) ? 'row expanded collapse' : 'hide' }>
					<div className="small-12 columns text-center">
							<NavLinks />
							<Social />
					</div>
				</div>
			</nav>
		)
	}
}

MainNav.propTypes = {  
};

export default MainNav;


// WEBPACK FOOTER //
// ./src/components/MainNav.js